import { render, staticRenderFns } from "./AccessCodePopup.vue?vue&type=template&id=248e2955&scoped=true&"
import script from "./AccessCodePopup.vue?vue&type=script&lang=ts&"
export * from "./AccessCodePopup.vue?vue&type=script&lang=ts&"
import style0 from "./AccessCodePopup.vue?vue&type=style&index=0&id=248e2955&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248e2955",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VRadio,VRadioGroup})
